import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters'
import { removeEnterpriseIsAuth, removeRealName, removeRefreshToken, removeToken, removeUserName, removeUserType } from '../utils/auth';

Vue.use(Vuex);

const defaulData = () => {
    return {
        userInfo: {}
    }
}

const store = new Vuex.Store({
    state: defaulData(),
    getters: getters,
    mutations: {
        RESET_STATE: state => {
            Object.assign(state, defaulData());
            window.localStorage.removeItem('userInfo');
        },
        SET_USER_INFO: (state, userInfo) => {
            state.userInfo = userInfo;
            window.localStorage.setItem('userInfo', JSON.stringify(userInfo))
        }
    },
    actions: {
        setUserInfo({ commit }, userInfo) {
            commit('SET_USER_INFO', userInfo);
        },
        resetToken({ commit }) {
            return new Promise(resolve => {
                removeToken(); // must remove  token  first
                removeRefreshToken();
                removeUserName();
                removeUserType();
                removeRealName();
                removeEnterpriseIsAuth();
                commit("RESET_STATE");
                window.sessionStorage.removeItem('userInfo');
                resolve();
            });
        }
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js